<template>
  <Layout>
    <Title
      title="Serviços"
      margin="large"
      :hasPrint="true"
      hasNewRegister
      newRegisterButtonName="Novo Serviço"
      :routeNewRegister="add"
    />
    <Table
      :tableData="tableData"
      :items="summaryServices"
      :pagination="true"
      :perPage="paginationService.perPage"
      :startItem="paginationService.startItem"
      :endItem="paginationService.endItem"
      :totalItems="paginationService.totalItems"
      :page="paginationService.currentPage"
      :onClickRow="handleRowClick"
      :onSearch="search"
      @changeItemsPerPage="changeItemsPerPage"
      @changePage="changePage"
    />
  </Layout>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { Layout, Title, Table, Actions, TableData } from '@/components';
import { numberBR } from '@/core/helpers/formater/number';

export default {
  name: 'InventoryServiceList',
  components: {
    Layout,
    Title,
    Table,
  },
  async mounted() {
    await this.resetServiceState();

    try {
      await this.setLoading(true);
      await this.setSummaryServices({
        pagination: this.paginationService,
      });
      this.setLoading(false);
    } catch {
      this.setLoading(false);
    }
  },
  props: {
    confirm: {
      type: Function,
    },
  },
  methods: {
    ...mapActions('service', [
      'resetServiceState',
      'deleteServices',
      'setSummaryServices',
    ]),
    ...mapActions('application', ['setLoading']),
    add() {
      this.$router.push('/cadastre/services/new');
    },
    handleRowClick(item) {
      this.$router.push(`/cadastre/services/edit/${item.id}`);
    },
    async search(value) {
      await this.setLoading(true);
      await this.setSummaryServices({
        search: value,
        pagination: { ...this.paginationService, currentPage: 1 },
      });
      await this.setLoading(false);
    },
    async changeItemsPerPage(items) {
      const pagination = {
        ...this.paginationService,
        perPage: items,
        currentPage: 1,
      };
      await this.setLoading(true);
      await this.setSummaryServices({ search: null, pagination });
      await this.setLoading(false);
    },
    async changePage(page) {
      const pagination = { ...this.paginationService, currentPage: page };
      await this.setLoading(true);
      await this.setSummaryServices({
        search: null,
        pagination,
      });
      await this.setLoading(false);
    },
  },
  computed: {
    ...mapState('service', [
      'paginationService',
      'summaryServices',
      'warnings',
    ]),
    tableData() {
      const { Data, TABLE_CELL_ALIGN, TABLE_CELL_CUSTOM } = TableData;
      const DataTable = new Data({
        panelActions: true,
        panelActionsSearch: true,
        select: true,
        titleMobile: (item) => item.description,
        onSearch: this.search,
      });

      DataTable.addField({
        key: 'sequence',
        label: 'Código',
        sortable: true,
        align: TABLE_CELL_ALIGN.center,
        width: 100,
      })
        .addField({
          key: 'description',
          label: 'Descrição',
          customClass: 'ellipsis',
        })
        .addField({
          key: 'groupName',
          label: 'Grupo',
        })
        .addField({
          key: TABLE_CELL_CUSTOM.status,
          label: 'Status',
          width: 100,
          align: TABLE_CELL_ALIGN.center,
          formatter: (value, field, items) => ({
            value: items.active ? 'Ativo' : 'Inativo',
            color: items.active ? 'success' : 'danger',
          }),
        })
        .addField({
          key: TABLE_CELL_CUSTOM.custom,
          label: 'Preço',
          align: TABLE_CELL_ALIGN.right,
          width: 100,
          formatter: (value, field, items) => numberBR(items.price, 2),
        })
        .addActions(
          Actions('delete', (selected) => {
            const services = selected.reduce((allServices, service) => {
              if (service?.id) {
                allServices.push(service.id);
              }
              return allServices;
            }, []);

            this.confirm({
              message: 'Tem certeza que deseja excluir?',
              type: 2,
              onOk: async () => {
                try {
                  this.setLoading(true);

                  const { ids } = await this.deleteServices(services);
                  await this.setSummaryServices({
                    pagination: this.paginationService,
                  });

                  if (ids.length) {
                    this.$alert.success('Registros excluídos com sucesso!');
                  }
                  if (this.warnings.length) {
                    this.warnings.forEach((i) => {
                      this.$alert.warning(i);
                    });
                  }
                } finally {
                  this.setLoading(false);
                }
              },
            });
          }),
        );
      return DataTable;
    },
  },
};
</script>
